import styled from 'styled-components'

export const Section = styled.section`
    padding: 2em;
    max-width: 1200px;
    margin: auto;

    @media only screen and (min-width: 768px) {
        padding: 2em 6em;
    }

    @media print {
        padding: 1em 0 !important;
        max-width: none;
    }

    ${ props => props.divider && `
        border-top: 1px solid ${ props.theme.colors.light };

        @media print {
            border-top-color: rgba(0, 0, 0, 0.15);
        }
    `}
`
